var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{staticClass:"left-sidebar-menu",attrs:{"default-active":_vm.$route.path},on:{"select":_vm.handleSelect}},[_c('el-menu-item',{attrs:{"index":"/abroad/account/companyInfo"}},[_c('i',{staticClass:"el-icon-menu company-info"}),_c('span',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t("title.companyInfo")))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }